import { jwtDecode } from 'jwt-decode';
import { JwtPayload } from './types';

// Log the status of AT - LI, LO, empty string, etc..
export const decodeATToken = (at: string) => {
  try {
    let jwtToken = at ? jwtDecode<JwtPayload>(at) : ({} as JwtPayload);

    return jwtToken;
  } catch {
    // Log the decode issue separately along with AT
    window?.NREUM?.addPageAction?.('FPG_AT_DECODE_ISSUE', {
      pageUrl: window.location.href,
      AT_STATUS_OR_VALUE: `${at}`
    });
  }
};

export const trackSNAndATDistribution = (
  at = '',
  sn = '',
  actionType: string
) => {
  window?.NREUM?.addPageAction?.(actionType, {
    pageUrl: window.location.href,
    AT_STATUS_OR_VALUE: `${at}`,
    SN_LOGGED_IN_STATUS: /\.LI$/i.test(sn)
  });
};

export const addCustomAttributeToNR = (key: string, value: string) => {
  window?.NREUM?.setCustomAttribute?.(key, value);
};

export const trackRequestFailure = (request: Request, response: Response) => {
  const requestHeadersMap: HeadersInit = {};
  const responseHeadersMap: HeadersInit = {};

  request.headers.forEach((value = '', key: string) => {
    //mask 'SN' and 'AT' values
    if (key === 'SN' || key === 'AT') {
      requestHeadersMap[key] = '*'.repeat(value.length);
    }
    requestHeadersMap[key] = value;
  });

  response.headers.forEach((value = '', key: string) => {
    responseHeadersMap[key] = value;
  });

  window?.NREUM?.addPageAction?.('FPG_REQUEST_FAILURE', {
    fkUA: request.headers.get('fkUA'),
    statusCode: response.status,
    requestUrl: request.url,
    referrer: request.referrer,
    requestHeaders: requestHeadersMap,
    responseHeaders: responseHeadersMap,
    responseStatus: response.ok,
    requestType: response.type
  });
};
export const extractDeviceID = (fkUA = '') => {
  /*
    Eg:
    
    Android: Mozilla/5.0 (Linux; Android 14; V2218 Build/UP1A.231005.007_IN) FKUA/Retail/1870100/Android/Mobile (vivo/V2218/90f73c4640bc4a5a23775be980e1dff8)

    IOS: Mozilla/5.0 (iPhone; CPU iPhone OS 17_3 like Mac OS X) AppleWebKit/602.4.6 (KHTML, like Gecko) Mobile/14D27; fk_ios_app FKUA/Retail/9.97.3/iOS/Mobile (Apple/iPhone14,5 17.3/8644C6A1BDAF4F729B83452F8F5DE300)
    
    Device id: Android => 90f73c4640bc4a5a23775be980e1dff8, IOS => 8644C6A1BDAF4F729B83452F8F5DE300
  */
  const fkUASplit = fkUA.split('/');

  const deviceId = fkUASplit[fkUASplit.length - 1];

  return deviceId.replace(')', '');
};

export const trackDCSwitchIssueOnFailure = ({
  failedDCId,
  dcIdFromBridge,
  apiURI,
  dcIdAppendedSource
}: {
  apiURI: string;
  failedDCId: string;
  dcIdFromBridge: string;
  dcIdAppendedSource: string;
}) => {
  window?.NREUM?.addPageAction?.('FPG_DC_SWITCH_ISSUE', {
    pageUrl: window.location.href,
    apiURI,
    failedDCId,
    dcIdFromBridge,
    dcIdAppendedSource
  });
};
